/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_TitleInputs */

const en_cases_title = /** @type {(inputs: Cases_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases`)
};

const pt_br2_cases_title = /** @type {(inputs: Cases_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos`)
};

/**
* | output |
* | --- |
* | "Cases" |
*
* @param {Cases_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_title = /** @type {((inputs?: Cases_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_title(inputs)
	return pt_br2_cases_title(inputs)
});